export default "__VITE_ASSET__CtemA5uZ__"